var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "313",
      "height": "273",
      "viewBox": "0 0 313 273",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M255.93 26.7941L248.759 30.2251C246.778 31.1727 244.405 30.3357 243.458 28.355C242.51 26.3744 243.347 24.0017 245.328 23.054L252.499 19.6231C254.479 18.6755 256.852 19.5125 257.8 21.4931C258.747 23.4737 257.91 25.8465 255.93 26.7941Z",
      "fill": "#ED6400"
    }
  }), _c('path', {
    attrs: {
      "d": "M244.107 40.5044C244.838 38.4347 247.108 37.3484 249.178 38.0785L256.674 40.7234C258.745 41.4542 259.831 43.7241 259.1 45.7943C258.37 47.864 256.099 48.9503 254.03 48.2202L246.533 45.5753C244.463 44.845 243.377 42.5751 244.107 40.5044Z",
      "fill": "#ED6400"
    }
  }), _c('path', {
    attrs: {
      "d": "M234.405 20.2243C236.475 20.9541 238.745 19.8678 239.475 17.7983L242.119 10.3016C242.849 8.23087 241.763 5.961 239.693 5.2307C237.623 4.50087 235.353 5.58711 234.623 7.65661L231.979 15.1534C231.248 17.2236 232.334 19.4935 234.405 20.2243Z",
      "fill": "#ED6400"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.3403 253.347L22.5357 249.967C24.523 249.034 25.3771 246.667 24.4436 244.68C23.5102 242.692 21.1436 241.838 19.1562 242.772L11.9608 246.151C9.9734 247.085 9.11939 249.451 10.0528 251.439C10.9862 253.426 13.3529 254.28 15.3403 253.347Z",
      "fill": "#ED6400"
    }
  }), _c('path', {
    attrs: {
      "d": "M33.4371 252.876C31.3724 252.132 29.0943 253.202 28.3494 255.266L25.6515 262.744C24.9066 264.809 25.9764 267.087 28.0413 267.832C30.106 268.576 32.3841 267.506 33.1289 265.442L35.8268 257.965C36.5719 255.9 35.5022 253.622 33.4371 252.876Z",
      "fill": "#ED6400"
    }
  }), _c('path', {
    attrs: {
      "d": "M23.8806 232.525C23.1353 234.59 20.8572 235.66 18.793 234.915L11.3156 232.216C9.25046 231.471 8.18074 229.193 8.92587 227.128C9.67122 225.064 11.9493 223.994 14.0135 224.739L21.4909 227.437C23.5558 228.182 24.6255 230.46 23.8806 232.525Z",
      "fill": "#ED6400"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#clip0_4107_48973)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M174.203 146.764C174.203 144.775 172.592 143.164 170.603 143.164H93.803C91.8143 143.164 90.2031 144.776 90.2031 146.764C90.2031 148.753 91.8143 150.364 93.803 150.364H170.603C172.591 150.364 174.203 148.753 174.203 146.764Z",
      "fill": "#07B53B"
    }
  }), _c('path', {
    attrs: {
      "d": "M188.844 226.685C191.323 229.992 195.271 231.966 199.403 231.966C203.536 231.966 207.484 229.992 209.964 226.686L260.364 159.486C264.731 153.664 263.546 145.374 257.723 141.006C251.9 136.639 243.61 137.823 239.243 143.646L236.603 147.167V45.9656C236.603 38.6874 230.681 32.7656 223.403 32.7656H69.8042C62.5251 32.7656 56.6038 38.6874 56.6038 45.9656V47.1657H48.2039C40.9252 47.1657 35.0039 53.0875 35.0039 60.3656V233.166C35.0039 240.444 40.9252 246.366 48.2039 246.366H56.6038V247.566C56.6038 254.844 62.5251 260.766 69.8037 260.766H223.403C230.681 260.766 236.603 254.844 236.603 247.566V209.165C236.603 207.177 234.992 205.566 233.003 205.566C231.014 205.566 229.403 207.177 229.403 209.165V247.566C229.403 250.874 226.711 253.566 223.403 253.566H69.8042C66.4955 253.566 63.804 250.874 63.804 247.566V93.9658C63.804 91.9771 62.1925 90.3659 60.2041 90.3659C58.2158 90.3659 56.6042 91.9775 56.6042 93.9658V239.166H48.2039C44.8952 239.166 42.2037 236.474 42.2037 233.166V60.3656C42.2037 57.057 44.8952 54.3655 48.2039 54.3655H56.6038V79.5653C56.6038 81.5541 58.2154 83.1652 60.2037 83.1652C62.192 83.1652 63.8036 81.5536 63.8036 79.5653V45.9656C63.8036 42.6569 66.4951 39.9654 69.8037 39.9654H223.403C226.711 39.9654 229.403 42.6569 229.403 45.9656V156.366C229.403 156.493 229.41 156.617 229.422 156.741L199.403 196.766L188.364 182.046C186.249 179.225 183.161 177.397 179.671 176.899C176.179 176.4 172.704 177.291 169.884 179.406C167.063 181.521 165.235 184.609 164.737 188.1C164.238 191.59 165.129 195.066 167.244 197.886L188.844 226.685ZM171.864 189.118C172.091 187.532 172.922 186.128 174.205 185.166C175.254 184.379 176.502 183.965 177.791 183.965C178.077 183.965 178.364 183.985 178.652 184.026C180.239 184.253 181.642 185.084 182.604 186.366L196.524 204.927C197.203 205.833 198.271 206.367 199.403 206.367C200.536 206.367 201.604 205.833 202.283 204.927L245.003 147.966C246.988 145.319 250.757 144.781 253.403 146.766C256.05 148.751 256.588 152.52 254.604 155.166L204.204 222.366C203.076 223.869 201.282 224.766 199.403 224.766C197.525 224.766 195.731 223.869 194.604 222.366L173.004 193.566C172.042 192.284 171.637 190.704 171.864 189.118Z",
      "fill": "#07B53B"
    }
  }), _c('path', {
    attrs: {
      "d": "M93.5999 95.1641C91.6111 95.1641 90 96.7752 90 98.764C90 100.753 91.6111 102.364 93.5999 102.364H146.4C148.389 102.364 150 100.753 150 98.764C150 96.7752 148.389 95.1641 146.4 95.1641H93.5999Z",
      "fill": "#ED6400"
    }
  }), _c('path', {
    attrs: {
      "d": "M93.803 131.165H170.603C172.592 131.165 174.203 129.553 174.203 127.565C174.203 125.576 172.592 123.965 170.603 123.965H93.803C91.8143 123.965 90.2031 125.576 90.2031 127.565C90.2031 129.553 91.8147 131.165 93.803 131.165Z",
      "fill": "#07B53B"
    }
  }), _c('path', {
    attrs: {
      "d": "M199.403 75.9648H93.803C91.8143 75.9648 90.2031 77.576 90.2031 79.5647C90.2031 81.5535 91.8143 83.1647 93.803 83.1647H199.403C201.391 83.1647 203.003 81.5535 203.003 79.5647C203.003 77.576 201.391 75.9648 199.403 75.9648Z",
      "fill": "#ED6400"
    }
  })]), _c('circle', {
    attrs: {
      "cx": "282.799",
      "cy": "95.0095",
      "r": "9.79853",
      "fill": "#ED6400"
    }
  }), _c('circle', {
    attrs: {
      "cx": "303.105",
      "cy": "154.597",
      "r": "7.14799",
      "stroke": "#07B53B",
      "stroke-width": "4"
    }
  }), _c('circle', {
    attrs: {
      "cx": "3.43987",
      "cy": "111.202",
      "r": "3.43987",
      "fill": "#07B53B"
    }
  }), _c('ellipse', {
    attrs: {
      "rx": "5",
      "ry": "5.5",
      "transform": "matrix(1 0 0 -1 278 195.711)",
      "fill": "#07B53B"
    }
  }), _c('circle', {
    attrs: {
      "cx": "8",
      "cy": "185.211",
      "r": "4",
      "fill": "#ED6400"
    }
  }), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_4107_48973"
    }
  }, [_c('rect', {
    attrs: {
      "width": "228",
      "height": "228",
      "fill": "white",
      "transform": "translate(35 32.7656)"
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }